module.exports = __webpack_public_path__ + "static/media/banner5.7e7a48f5.jpg";